module.exports = __webpack_public_path__ + "img/ticket.2ee3bce3.svg";